var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEasy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 60,
    viewBox: "0 0 115 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3645_55587",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 115,
    height: 60
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 115,
    height: 60,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3645_55587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.8107 17.7026L64.3203 26.7949L167.785 -126.936L154.275 -136.028L50.8107 17.7026Z",
    fill: "#FEC84D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6988 26.2292C64.3138 26.8013 48.4333 42.5737 48.4333 42.5737L41.628 38.1001L51.1916 17.1385C51.1916 17.1385 53.4763 15.1626 55.4675 15.7608C57.4588 16.3591 56.7542 20.2538 56.7542 20.2538L59.9546 18.6983C61.3699 19.7951 61.6971 23.5804 61.6971 23.5804L64.4481 22.1313C66.4498 23.4235 64.6988 26.2292 64.6988 26.2292Z",
    fill: "#FCD695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4455 42.5664C48.1359 42.8938 39.3872 51.3969 38.4015 50.7334C37.4157 50.07 41.6482 38.0809 41.6482 38.0809L48.4455 42.5664Z",
    fill: "#87867B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M77.1805 2.31698C96.5959 -28.0263 115.576 -52.3906 134.274 -83.0248C135.751 -85.4445 141.02 -92.0274 141.667 -94.2642C142.313 -96.5011 141.673 -98.1414 139.912 -97.0664C138.25 -96.0518 136.488 -91.2135 135.044 -88.9707C113.144 -54.9721 89.9883 -23.1792 67.4973 10.9124C65.1105 14.5301 61.695 21.3503 66.4415 17.5588C69.9128 14.774 74.5242 6.47805 77.1805 2.31698Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasy);
export default __webpack_public_path__ + "static/media/easy.bd006f49bbfc03c303ba443d06c071ba.svg";
export { ForwardRef as ReactComponent };